<app-table
  [cols]="cols()"
  [service]="subscriberService"
  pageFunctionName="requestSubscriberUpgradeRefund"
  sortField="dateRenewed"
  [sortOrder]="1"
  [defaultFilterValues]="{
    pendingRefund: 1
  }"
  [dropdownFilters]="dropdownFilters"
  expandField="subscriberRefunds"
  dataKey="subscriberRenewalId"
  [expansionCols]="refundsCols()"
  [expandPaginator]="false"
  [addButton]="false"
  modelName="estornos"
  tableTitle="Estornos de upgrades"
  (changedFilter)="filterChanged($event)"
  (emitSelection)="refreshTickets($event)"
  selectionActionLabel="Atualizar"
  selectionActionIcon="pi pi-refresh"
  selectionActionTooltip="Atualizar status de estorno dos tickets"
  [rowSelectable]="rowSelectable"
/>
